import { JwtPayload } from "jwt-decode";
import { useHostIdentity } from "./useHostIdentity";
import { useStorageIdentity } from "./useStorageIdentity";
import { getUrlToken } from "./getUrlToken";

export type Identity = {
    tokenV2: string,
    decodedV2: JwtPayload
}

export function useIdentity() {

    const storageIdentity = useStorageIdentity();
    const hostIdentity = useHostIdentity();

    return { getIdentity }

    function getIdentity() {

        return new Promise<Identity>((resolve, reject) => {


            // Check if there is a token in the URL first
            // this is mostly to be able to send the token to the uploader pop-up
            const token = getUrlToken();
            if (token) {
                const identity = {
                    tokenV2: token,
                    decodedV2: JSON.parse(atob(token.split('.')[1]))
                };
                storageIdentity.setIdentity(identity);
                resolve(identity);
                return;
            }

            //look for a valid token in the session storage
            const identity = storageIdentity.getIdentity();

            if (identity) {
                resolve(identity)
                storageIdentity.setIdentity(identity);
                return
            }

            //fallback => request a token from the host application
            return hostIdentity.getIdentity()
                .then((identity) => {
                    storageIdentity.setIdentity(identity);
                    resolve(identity);
                })
                .catch(reject);
        });
    };
}

export default useIdentity;